// extracted by mini-css-extract-plugin
module.exports = {"tabs":"EntrancesTabs_tabs__2hCsr","tab":"EntrancesTabs_tab__AZBMy","tabActive":"EntrancesTabs_tabActive__rwWhD"};